import { useCallback } from 'react'

// utils
import { setApprovalForAll } from '../../sushi/utils'
import { userBidNFTContract } from '../../userType/userBidNFTContract'
import { userNFTContract } from '../../userType/userNFTContract'
import { userNFTMasterContract } from '../../userType/userNFTMasterContract'

import { MARKETTYPE, MARKETMULTITOKEN, MARKETTYPEV1, MARKETTYPEV3 } from '../../constants/bakery/nft'
import { multiTokenExchangeNftContract } from '../../userType/multiTokenExchangeNftContract'

// hooks
import useYam from '../bakery/useYam'
import { useActiveWeb3React } from '..'
import { userExchangeNFTContract } from '../../userType/userExchangeNFTContract'
import { userV3NFTContract } from '../../userType/userV3NFTContract'

const useApproveAllERC721 = (type?: any, marketFlag?: string) => {
  const { account } = useActiveWeb3React()
  const sushi = useYam()
  let erc721Contract = userNFTContract(sushi, type)
  let contract:any
  if(marketFlag === 'market'){
    if(type && MARKETTYPE.hasOwnProperty(type)){
      contract = userBidNFTContract(sushi, type)
    }else if(type && MARKETMULTITOKEN.hasOwnProperty(type)){
      contract = multiTokenExchangeNftContract(sushi, type)
    }else if (type && MARKETTYPEV1.hasOwnProperty(type)) {
      contract = userExchangeNFTContract(sushi, type)
    }else if (type && MARKETTYPEV3.hasOwnProperty(type)) {
      contract = userV3NFTContract(sushi, type)
    }
  }else {
    contract = userNFTMasterContract(sushi, type)
  }

  const handleApprove = useCallback(async () => {
    try {
      const tx = await setApprovalForAll(erc721Contract, contract, account)
      return tx
    } catch (e) {
      return false
    }
  }, [account, erc721Contract, contract])

  return handleApprove
}

export default useApproveAllERC721
